export default{name:'adduprightbtn',props:['isVisible'],methods:{emitClick:function emitClick(){this.$emit('click')}},computed:{compIsVisible:function compIsVisible(){return this.isVisible}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/EditUprightBtn.vue
// module id = 246
// module chunks = 0